import { SystemField } from "./system-field";

export class PosPermission extends SystemField{ 
     make_order?:number;
     make_payment?:number;
     access_admin?:number;
     profile_id?:string;
}
